import React, { useState, useEffect } from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import Dropzone from 'react-dropzone';

import messages from '../messages';
import { Api } from '../api';
import { toast } from 'react-toast';

const showError = (message) => toast(message, { backgroundColor: '#f2dede', color: '#a94442' });

const FileField = ({ sendDraft, draftId, input, defaultValue }) => {
  const [files, setFiles] = useState([]);

  useEffect(() => {
    if (defaultValue instanceof Array) {
      setFiles(defaultValue);
    }
  }, [defaultValue]);

  const uploadToServer = async (file) => {
    const draft_id = await sendDraft();
    const formData = new FormData();

    formData.append('file', file);
    formData.append('draft_id', draftId || draft_id);

    Api.uploadFile(formData, (err) => {
      if (err.status === 422) {
        err.response.body.forEach((e) => {
          showError(e.message);
        });
      } else if (err.message) {
        showError(err.message);
      } else {
        showError(<FormattedMessage {...messages.error} />);
      }
    }).then((resp) => {
      if (resp.ok) {
        setFiles((prevState) => {
          const isDublicate = prevState.find((f) => f.file_id === resp.body.id);
          const newState = isDublicate
            ? prevState
            : [...prevState, { name: file.name, file_type_id: 2, file_id: resp.body.id }];

          input.onChange(newState);

          return newState;
        });
      } else {
        showError(<FormattedMessage {...messages.error} />);
      }
    });
  };

  const onDrop = (acceptedFiles, rejectedFiles) => {
    if (acceptedFiles.length + files.length > 10)
      return showError(<FormattedMessage {...messages.maxNumberOverflow} />);
    if (rejectedFiles.length > 0) return showError(<FormattedMessage {...messages.notAccepted} />);
    acceptedFiles.forEach((file) => {
      const fileSize = Math.round(file.size / 1024);

      if (fileSize > 10240) {
        return showError(
          <FormattedHTMLMessage
            {...messages.fileSizeValidation}
            values={{ file_name: file.name }}
          />
        );
      }
      uploadToServer(file);
    });
  };

  const removeUploadedFile = (file) => {
    Api.deleteUploadedFile({ file_id: file.file_id, draft_id: draftId }).then((resp) => {
      if (resp.ok && resp.body.success) {
        setFiles((prevState) => {
          const filteredFiles = prevState.filter((f) => f.file_id !== file.file_id);
          input.onChange(filteredFiles);
          return filteredFiles;
        });
      } else {
        showError(resp.body.message);
      }
    });
  };

  return (
    <span>
      <Dropzone style={{ border: 0 }} onDrop={onDrop}>
        <div id="user_file_org_box" className="fileUploaderBox">
          <div id="user_file_org" className="btn btn-primary waves-effect waves-light">
            <i className="icon-file icon-white"></i>
            <FormattedMessage {...messages.uploadFile} />
          </div>
          <div className="file-path-wrapper" style={{ display: 'inline-block' }}>
            <input readOnly="" id="filename" className="file-path" type="text" />
          </div>
          <div className="col-md-12 text-justify">
            <p className="note">
              <FormattedMessage {...messages.fileSize} />
            </p>
          </div>
          <div className="clearfix"></div>
        </div>
      </Dropzone>
      <div className="dropZone fileUploaderFilesListBox">
        <ul
          id="user_fileFilesList"
          className="fileUploaderFilesList"
          style={{ border: 0, margin: 0, padding: 0 }}>
          {files.map((file) => (
            <li className="fuPill fu-Success" key={file.file_id}>
              <a
                className="cancelBtn deleteButton"
                onClick={() => removeUploadedFile(file)}
                style={{ width: 'auto' }}>
                <span>×</span>
              </a>
              <div style={{ marginTop: 10 }}>
                <p className="fileUploaderFileName">{file.name}</p>
                <p className="fuMessage">
                  <FormattedMessage {...messages.fileUploaded} />
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </span>
  );
};

export default FileField;



// WEBPACK FOOTER //
// ./src/application-form/field-components/file.js